import { cva, type VariantProps } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
    'inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground shadow hover:bg-primary/80',
                secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
                destructive: 'bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
                success: 'border border-green-500/20 bg-green-500/15 text-green-600 dark:text-green-400',
                warning: 'border border-yellow-500/20 bg-yellow-500/15 text-yellow-600 dark:text-yellow-400',
                resell: 'border border-resell/20 bg-resell/15 text-resell-foreground',
                tradein: 'border border-tradein/20 bg-tradein/15 text-tradein-foreground',
                outline: 'border text-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
